/* ============================================================
   SST — Cart add (product cards)
   Self-contained add-to-cart for single-variant product cards.
   POSTs to /cart/add.js, refreshes the header cart icon + drawer
   body via the Section Rendering API, then opens Dawn's cart drawer.
   Avoids Dawn's product-form section-injection path.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sst-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;
    add(btn);
  });

  function add(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    setLoading(btn, true);

    var drawer = document.querySelector('cart-drawer');
    var sectionIds = ['cart-icon-bubble'];
    if (drawer) sectionIds.push('cart-drawer');

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { showError(btn, data.description || data.message); return; }
        if (data.sections) renderSections(data.sections);
        openDrawer(drawer);
        publishUpdate(data);
      })
      .catch(function () { showError(btn, 'Something went wrong. Please try again.'); })
      .finally(function () { setLoading(btn, false); });
  }

  function renderSections(sections) {
    // Header cart icon
    if (sections['cart-icon-bubble']) {
      var mount = document.getElementById('cart-icon-bubble');
      var frag = parse(sections['cart-icon-bubble'], '.shopify-section') || parse(sections['cart-icon-bubble'], null);
      if (mount && frag) mount.innerHTML = frag.innerHTML;
    }
    // Drawer body
    if (sections['cart-drawer']) {
      var target = document.querySelector('cart-drawer #CartDrawer') || document.querySelector('#CartDrawer');
      var src = parse(sections['cart-drawer'], '#CartDrawer');
      if (target && src) target.replaceChildren.apply(target, src.childNodes);
    }
  }

  function parse(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return selector ? doc.querySelector(selector) : doc.body;
  }

  function openDrawer(drawer) {
    if (drawer) {
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') { drawer.open(); return; }
    }
    // No drawer (notification/page cart) → go to cart page.
    window.location = (window.routes && window.routes.cart_url) || '/cart';
  }

  function publishUpdate(data) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sst-card', cartData: data });
    }
  }

  function setLoading(btn, on) {
    btn.classList.toggle('sst-is-loading', on);
    btn.setAttribute('aria-disabled', on ? 'true' : 'false');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
  }

  function showError(btn, msg) {
    var wrap = btn.closest('.sst-product-card').querySelector('[data-sst-add-error]');
    if (wrap) { wrap.textContent = msg; wrap.hidden = false; }
  }
})();
